import { renderEmail } from '@/components/CellRenders';
import DatePreview from '@/components/DatePreview';
import Phones from '@/components/PhoneNumberField/PhonesListView';
import { renderUser } from '@/modules/admin/components/UserCell';
import { renderUserOfficeCell } from '@/modules/admin/components/UserOfficeCell';
import { renderUserActions } from '@/modules/admin/components/UserRowActions';
import { renderUserStatus } from '@/modules/admin/components/UserStatus';
import { renderUserType } from '@/modules/admin/components/UserType';
import { i18n } from '@/settings';

export const columns = [
  {
    key: 'name',
    title: 'name',
    sorteable: true,
    dataIndex: 'fullName',
    render: renderUser
  },
  {
    key: 'idNumber',
    ellipsis: true,
    title: 'user.form.idNumber.placeholder',
    dataIndex: 'idNumber',
    sorteable: true,
    align: 'center',
    responsive: ['lg'],
  },
  {
    key: 'email',
    title: 'email',
    dataIndex: 'email',
    render: renderEmail,
    responsive: ['lg'],
  },
  {
    key: 'phone',
    title: 'phones',
    dataIndex: 'phone',
    ellipsis: true,
    width: 150,
    align: 'center',
    // eslint-disable-next-line react/display-name
    render: (value) => <Phones value={value} useLink={false} columns showType={false}/>,
    responsive: ['lg']
  },
  {
    key: 'status',
    title: 'status',
    dataIndex: 'status',
    sorteable: true,
    render: renderUserStatus,
    responsive: ['md'],
  },
  {
    key: 'updatedAt',
    title: 'updatedAt',
    ellipsis: true,
    align: 'center',
    dataIndex: 'updatedAt',
    type: 'date',
    sorteable: true,
    responsive: ['lg'],
    // eslint-disable-next-line react/display-name
    render: (value) => <DatePreview value={value} defaultValue={'-'} format={'ll hh:mm a'}/>,
  },
  {
    key: 'loginFailCount',
    title: 'loginFailCount',
    ellipsis: true,
    align: 'center',
    dataIndex: 'loginFailCount',
    sorteable: true,
    responsive: ['lg'],
    render: (value) => value || '-',
  },
  {
    key: 'lockedUntil',
    title: 'lockedUntil',
    ellipsis: true,
    align: 'center',
    dataIndex: 'lockedUntil',
    type: 'date',
    sorteable: true,
    responsive: ['lg'],
    // eslint-disable-next-line react/display-name
    render: (value) => <DatePreview value={value} defaultValue={'-'} format={'ll hh:mm a'}/>
  },
  {
    key: 'metadata.office',
    ellipsis: true,
    align: 'center',
    title: 'user.form.office.placeholder',
    dataIndex: ['metadata', 'office'],
    render: renderUserOfficeCell,
    responsive: ['md'],
  },
  {
    key: 'createdAt',
    title: 'registerAt',
    type: 'date',
    align: 'center',
    dataIndex: 'createdAt',
    sorteable: true,
    width: 150,
    responsive: ['lg'],
  },
  {
    key: 'lastLoginAt',
    title: 'lastLoginAt',
    ellipsis: true,
    type: 'date',
    align: 'center',
    dataIndex: 'lastLoginAt',
    sorteable: true,
    width: 150,
    responsive: ['lg'],
    // eslint-disable-next-line react/display-name
    render: (value) => <DatePreview value={value} format={'ll hh:mm a'}/>,
  },
  {
    key: 'lastLoginIp',
    title: 'lastLoginIp',
    ellipsis: true,
    align: 'center',
    dataIndex: 'lastLoginIp',
    width: 150,
    responsive: ['lg'],
    // eslint-disable-next-line react/display-name
    render: (value) => value ? (value === '::1' ? `${value} (127.0.0.1)` : value) : '-',
  },
  {
    key: 'userType',
    title: 'user.userType',
    dataIndex: 'userType',
    align: 'center',
    sorteable: true,
    ellipsis: true,
    render: renderUserType,
    responsive: ['md'],
  },
  {
    key: 'role',
    title: 'roles',
    type: 'list',
    setting: {
      tag: true,
      renderField: 'role.name',
      customMapFunc: (item) => {
        const exist = i18n.exists(`admin:rol.${item?.role?.name}`);
        return ({
          ...item,
          role: { ...item.role, name: exist ? i18n.t(`admin:rol.${item?.role?.name}`) : item?.role?.name }
        });
      },
      conditionalColor: (item) => item?.role?.superAdmin ? 'processing' : undefined
    },
    dataIndex: 'roles',
    responsive: ['lg'],
  },
  {
    key: 'actions',
    title: 'actions',
    dataIndex: 'actions',
    align: 'center',
    width: 100,
    render: renderUserActions('/admin/users')
  }
];
